import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

interface Review {
  id: string;
  title: string;
  author: string;
  cover: string;
  coverAlt: string;
  rating: number;
  genre: string;
  reviewDate: string;
  reviewExcerpt: string;
  readingTime: string;
}

const allReviews: Review[] = [
{
  id: 'review_1',
  title: 'The Midnight Library',
  author: 'Matt Haig',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1b87a6d05-1766775987298.png",
  coverAlt: 'The Midnight Library book cover showing dark blue background with golden library illustration',
  rating: 4.5,
  genre: 'Fiction',
  reviewDate: '2026-01-28',
  reviewExcerpt: 'A profound exploration of life choices and infinite possibilities. Haig crafts a narrative that feels both deeply personal and universally relatable, examining the roads not taken with compassion and wisdom. While the concept is ambitious, the execution occasionally stumbles with heavy-handed philosophical musings. Nevertheless, this is a book that will resonate with anyone who\'s ever wondered "what if?"',
  readingTime: '8 min read'
},
{
  id: 'review_2',
  title: 'Project Hail Mary',
  author: 'Andy Weir',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1b8589ffb-1765370251985.png",
  coverAlt: 'Project Hail Mary book cover with space and rocket imagery on dark background',
  rating: 5.0,
  genre: 'Science Fiction',
  reviewDate: '2026-01-25',
  reviewExcerpt: 'Weir delivers another masterpiece of hard science fiction with heart. The protagonist\'s journey from amnesia to heroism is compelling, and the scientific problem-solving is both accurate and accessible. The alien encounter subplot is handled with surprising emotional depth. This is everything The Martian was and more—a perfect blend of humor, science, and humanity facing impossible odds.',
  readingTime: '10 min read'
},
{
  id: 'review_3',
  title: 'The Seven Husbands of Evelyn Hugo',
  author: 'Taylor Jenkins Reid',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1f2d2c4a5-1765370248901.png",
  coverAlt: 'The Seven Husbands of Evelyn Hugo book cover with elegant vintage Hollywood aesthetic',
  rating: 4.8,
  genre: 'Historical Fiction',
  reviewDate: '2026-01-22',
  reviewExcerpt: 'A captivating tale of love, ambition, and Hollywood glamour that spans decades. Reid creates an unforgettable protagonist in Evelyn Hugo—complex, flawed, and utterly human. The narrative structure keeps you guessing, and the emotional payoff is earned. This is more than a story about Old Hollywood; it\'s a meditation on identity, sacrifice, and the stories we choose to tell.',
  readingTime: '9 min read'
},
{
  id: 'review_4',
  title: 'Atomic Habits',
  author: 'James Clear',
  cover: "https://images.unsplash.com/photo-1716171848317-1ca95b7f99ef",
  coverAlt: 'Atomic Habits book cover with minimalist design and bold typography',
  rating: 4.7,
  genre: 'Self-Help',
  reviewDate: '2026-01-20',
  reviewExcerpt: 'A practical, science-backed guide to building good habits and breaking bad ones. Clear\'s framework is refreshingly simple without being simplistic. The emphasis on systems over goals is particularly valuable. While some examples feel repetitive, the core concepts are solid and immediately applicable. This is one of those rare self-help books that actually helps.',
  readingTime: '7 min read'
},
{
  id: 'review_5',
  title: 'The Silent Patient',
  author: 'Alex Michaelides',
  cover: "https://images.unsplash.com/photo-1709671704815-29c6dccb0adc",
  coverAlt: 'The Silent Patient book cover with mysterious woman silhouette on dark background',
  rating: 4.3,
  genre: 'Thriller',
  reviewDate: '2026-01-18',
  reviewExcerpt: 'A psychological thriller that keeps you guessing until the very end. The twist is genuinely shocking, though some may find the setup a bit contrived in retrospect. Michaelides creates an atmosphere of mounting dread that propels you through the pages. The exploration of trauma and art adds depth to what could have been a simple mystery. A solid debut that thriller fans will devour.',
  readingTime: '8 min read'
},
{
  id: 'review_6',
  title: 'Educated',
  author: 'Tara Westover',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1a67dd3db-1766575716473.png",
  coverAlt: 'Educated memoir book cover with mountain landscape and graduation cap imagery',
  rating: 4.9,
  genre: 'Biography',
  reviewDate: '2026-01-15',
  reviewExcerpt: 'A powerful memoir about education, family, and self-discovery. Westover\'s journey from isolated childhood to PhD is remarkable, but what makes this book exceptional is her nuanced exploration of family loyalty versus self-preservation. The prose is elegant without being showy. This is a story about the transformative power of learning that will stay with you long after you finish.',
  readingTime: '11 min read'
},
{
  id: 'review_7',
  title: 'Where the Crawdads Sing',
  author: 'Delia Owens',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1704451fb-1764675693824.png",
  coverAlt: 'Where the Crawdads Sing book cover with marsh landscape and watercolor aesthetic',
  rating: 4.4,
  genre: 'Fiction',
  reviewDate: '2026-01-12',
  reviewExcerpt: 'A beautifully written coming-of-age story set in the marshlands. Owens\' nature writing is exquisite, making the marsh itself a character. The mystery element adds momentum, though the romance feels somewhat formulaic. Kya is a compelling protagonist whose resilience and intelligence shine. This is literary fiction that doesn\'t sacrifice plot for prose—a rare and welcome combination.',
  readingTime: '9 min read'
},
{
  id: 'review_8',
  title: 'The Name of the Wind',
  author: 'Patrick Rothfuss',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1ae824976-1769488098492.png",
  coverAlt: 'The Name of the Wind fantasy book cover with magical elements and medieval aesthetic',
  rating: 4.6,
  genre: 'Fantasy',
  reviewDate: '2026-01-10',
  reviewExcerpt: 'An epic fantasy with masterful prose and a complex magic system. Rothfuss writes with a literary sensibility rare in the genre. Kvothe is a fascinating protagonist—brilliant, flawed, and unreliable. The frame narrative adds depth, though some may find the pacing uneven. This is fantasy for readers who appreciate beautiful language as much as adventure. Just be warned: the series is incomplete.',
  readingTime: '12 min read'
}];


export default function ReviewFeed() {
  return (
    <section className="py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="space-y-8">
          {allReviews.map((review) =>
          <Link
            key={review.id}
            href="/book-reviews"
            className="group cursor-pointer block">

              <article className="glass-card rounded-xl overflow-hidden hover:bg-card/80 transition-all duration-300">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-6 p-6">
                  {/* Book Cover */}
                  <div className="md:col-span-3">
                    <div className="relative h-64 md:h-full overflow-hidden rounded-lg bg-muted">
                      <AppImage
                      src={review.cover}
                      alt={review.coverAlt}
                      className="w-full h-full object-cover image-hover-zoom grayscale group-hover:grayscale-0 transition-all duration-700" />

                      <div className="absolute top-4 right-4 flex items-center gap-1 px-3 py-1.5 rounded-full bg-background/90 backdrop-blur-sm">
                        <Icon name="StarIcon" size={14} className="text-accent" />
                        <span className="text-sm font-semibold text-foreground">{review.rating}</span>
                      </div>
                    </div>
                  </div>

                  {/* Review Content */}
                  <div className="md:col-span-9 flex flex-col justify-between">
                    <div>
                      {/* Meta Info */}
                      <div className="flex flex-wrap items-center gap-3 mb-4">
                        <span className="text-xs uppercase tracking-widest text-primary font-semibold">
                          {review.genre}
                        </span>
                        <span className="text-xs text-muted-foreground">•</span>
                        <span className="text-xs text-muted-foreground">
                          {new Date(review.reviewDate).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
                        </span>
                        <span className="text-xs text-muted-foreground">•</span>
                        <span className="text-xs text-muted-foreground">{review.readingTime}</span>
                      </div>

                      {/* Title & Author */}
                      <h2 className="text-2xl md:text-3xl font-serif font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                        {review.title}
                      </h2>
                      <p className="text-base text-muted-foreground mb-4">
                        by {review.author}
                      </p>

                      {/* Excerpt */}
                      <p className="text-foreground/80 leading-relaxed line-clamp-3">
                        {review.reviewExcerpt}
                      </p>
                    </div>

                    {/* Read More */}
                    <div className="flex items-center gap-2 text-primary mt-6 opacity-0 group-hover:opacity-100 transition-opacity">
                      <span className="text-sm font-medium">Read Full Review</span>
                      <Icon name="ArrowRightIcon" size={16} />
                    </div>
                  </div>
                </div>
              </article>
            </Link>
          )}
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-center gap-2 mt-16">
          <button className="w-10 h-10 rounded-lg border border-border bg-card flex items-center justify-center hover:border-primary hover:bg-card/80 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
            <Icon name="ChevronLeftIcon" size={20} className="text-foreground" />
          </button>

          {[1, 2, 3, 4, 5].map((page) =>
          <button
            key={`page_${page}`}
            className={`w-10 h-10 rounded-lg flex items-center justify-center text-sm font-medium transition-colors ${
            page === 1 ?
            'bg-primary text-primary-foreground' :
            'border border-border bg-card text-foreground hover:border-primary hover:bg-card/80'}`
            }>

              {page}
            </button>
          )}

          <button className="w-10 h-10 rounded-lg border border-border bg-card flex items-center justify-center hover:border-primary hover:bg-card/80 transition-colors">
            <Icon name="ChevronRightIcon" size={20} className="text-foreground" />
          </button>
        </div>
      </div>
    </section>);

}